// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*main img {*/
/*    width: 250px;*/
/*    height: 250px;*/
/*}*/

.ant-steps-item-title {
    font-size: 14px;
}

.stage-maintenance-container .ant-spin-container {
    display: flex;
    justify-content: center;
}


.action-button {
    background-color: #FF6969;
    color: white;
    border-color: #FF6969;
}

.action-button:hover {
    background-color: #FF6969;
    color: white;
    border-color: #FF6969;
}

.nav-button {
    background-color: #FFD3B0;
    color: #0b1c3b;
    border-color: #FFD3B0;
}

.nav-button:hover {
    background-color: #FFD3B0;
    color: #0b1c3b;
    border-color: #FFD3B0;
}

.stage-cleanup-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 50px;
    background-color: rgba(255, 255, 255, 0.9);
    padding: 30px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
    z-index: 1000;
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
}

.message {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
    border-radius: 4px;
    font-size: 16px;
    color: #fff;
    text-align: center;
    width: 100%;
}

.message p {
    margin: 10px;
}

.message.error {
    background-color: #e74c3c; /* a darker shade of red */
    border: 1px solid #e74c3c;
}

.message.success {
    background-color: #27ae60; /* a darker shade of green */
    border: 1px solid #2ecc71;
}
`, "",{"version":3,"sources":["webpack://./src/view/c240/c240_stage_cleanup.css"],"names":[],"mappings":"AAAA,aAAa;AACb,oBAAoB;AACpB,qBAAqB;AACrB,IAAI;;AAEJ;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;;AAGA;IACI,yBAAyB;IACzB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,0CAA0C;IAC1C,aAAa;IACb,qCAAqC;IACrC,aAAa;IACb,eAAe;IACf,MAAM;IACN,QAAQ;IACR,OAAO;AACX;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB,EAAE,0BAA0B;IACrD,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB,EAAE,4BAA4B;IACvD,yBAAyB;AAC7B","sourcesContent":["/*main img {*/\n/*    width: 250px;*/\n/*    height: 250px;*/\n/*}*/\n\n.ant-steps-item-title {\n    font-size: 14px;\n}\n\n.stage-maintenance-container .ant-spin-container {\n    display: flex;\n    justify-content: center;\n}\n\n\n.action-button {\n    background-color: #FF6969;\n    color: white;\n    border-color: #FF6969;\n}\n\n.action-button:hover {\n    background-color: #FF6969;\n    color: white;\n    border-color: #FF6969;\n}\n\n.nav-button {\n    background-color: #FFD3B0;\n    color: #0b1c3b;\n    border-color: #FFD3B0;\n}\n\n.nav-button:hover {\n    background-color: #FFD3B0;\n    color: #0b1c3b;\n    border-color: #FFD3B0;\n}\n\n.stage-cleanup-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    height: 50px;\n    background-color: rgba(255, 255, 255, 0.9);\n    padding: 30px;\n    box-shadow: 0 2px 4px rgba(0,0,0,0.2);\n    z-index: 1000;\n    position: fixed;\n    top: 0;\n    right: 0;\n    left: 0;\n}\n\n.message {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 20px;\n    border-radius: 4px;\n    font-size: 16px;\n    color: #fff;\n    text-align: center;\n    width: 100%;\n}\n\n.message p {\n    margin: 10px;\n}\n\n.message.error {\n    background-color: #e74c3c; /* a darker shade of red */\n    border: 1px solid #e74c3c;\n}\n\n.message.success {\n    background-color: #27ae60; /* a darker shade of green */\n    border: 1px solid #2ecc71;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
